import SaveNotification from 'src/components/common/SaveNotification'
import CODAvailability from 'src/components/rto-suite/CODAvailability'
import CODToPrepaid from 'src/components/rto-suite/CODToPrepaid'
import FraudulentOrders from 'src/components/rto-suite/FraudentOrders'
import MandatoryOtp from 'src/components/rto-suite/MandatoryOtp'
import SplitCOD from 'src/components/rto-suite/SplitCOD'
import { useRTOSuitePermissions } from 'src/lib/access-permission-hooks/useRTOSuitePermissions'
import { useShippingPermissions } from 'src/lib/access-permission-hooks/useShippingPermissions'
import { useRtoSuiteContext } from 'src/lib/contexts/RTOSuiteProvider'
import { useLocale } from 'src/lib/hooks/useLocal'
import { rtoSuiteAddressMinLength } from 'src/lib/utils/constants'
import AddressFormSettings from './AddressFormSettings'
import DynamicCODBlocking from './DynamicCODBlocking'
import EnableRtoRiskProfiling from './EnableRtoRiskProfiling'

const RTOSuitePage = () => {
  const { t } = useLocale()
  const setDiscardChanges = useRtoSuiteContext(context => context.actions?.setDiscardChanges)
  const setSaveChanges = useRtoSuiteContext(context => context.actions?.setSaveChanges)
  const state = useRtoSuiteContext(context => context?.state)
  const initialRtoState = useRtoSuiteContext(context => context?.initialRtoState)

  const { canViewShippingDeliveryV2 } = useShippingPermissions()
  const { canViewCODToPrepaid } = useRTOSuitePermissions()

  const saveChanges = () => {
    setSaveChanges()
  }
  const discardChanges = () => {
    setDiscardChanges()
  }

  const shouldShowSaveNotification = () => {
    const { addressConfig } = state
    if (
      addressConfig.addressLine1.minCharacterLimit < rtoSuiteAddressMinLength ||
      (addressConfig.addressLine2.isMandatory &&
        addressConfig.addressLine2.minCharacterLimit < rtoSuiteAddressMinLength)
    ) {
      return false
    }
    return JSON.stringify(initialRtoState) !== JSON.stringify(state)
  }

  return (
    <div className='flex flex-col gap-4 xl:w-4/5 max-h-full p-8' data-track-id='rto-suite-page'>
      <h2 className='font-semibold text-carbon text-xl'>{t('rto_suite')}</h2>
      <div className='flex flex-col  p-4 bg-white border rounded border-gray-light' data-track-id='reduce-cod-section'>
        <div className='flex flex-col gap-1 font-semibold text-carbon pb-6'>
          <h2 className='font-medium text-[18px]'>{t('reduce_cod')}</h2>
          <p className='text-sm leading-5 font-normal text-gray-dark'>
            {t('tools_and_strategies_to_minimize_cod_orders')}
          </p>
        </div>
        <SplitCOD />
        {canViewCODToPrepaid && (
          <>
            <div className='border-t-1'></div>
            <CODToPrepaid />
          </>
        )}
        <div className='border-t-1'></div>
        {canViewShippingDeliveryV2 && <CODAvailability />}
        <div className='border-t-1'></div>
        <DynamicCODBlocking />
      </div>
      <div
        className='flex flex-col  p-4 bg-white border rounded border-gray-light'
        data-track-id='prevent-fraudulent-orders-section'
      >
        <div className='flex flex-col gap-1 font-semibold text-carbon pb-6'>
          <h2 className='font-medium text-[18px]'>{t('prevent_fraudulent_orders')}</h2>
          <p className='text-sm leading-5 font-normal text-gray-dark'>{t('prevent_fraudulent_orders_description')}</p>
        </div>
        <MandatoryOtp />
        <FraudulentOrders />
      </div>
      <div className='flex flex-col p-4 bg-white border rounded border-gray-light'>
        <div className='flex flex-col gap-1 font-semibold text-carbon pb-6'>
          <h2 className='font-medium text-[18px]'>{t('rto_risk_profiling')}</h2>
          <p className='font-normal text-gray-dark text-sm leading-5'>{t('rto_risk_profiling_description')}</p>
        </div>

        <EnableRtoRiskProfiling />
      </div>
      <div
        className='flex flex-col  p-4 bg-white border rounded border-gray-light'
        data-track-id='address-form-settings-section'
      >
        <div className='flex flex-col gap-1 font-semibold text-carbon pb-6'>
          <h2 className='font-medium text-[18px]'>{t('address_form_settings')}</h2>
          <p className='font-normal text-gray-dark text-sm leading-5'>{t('address_form_settings_description')}</p>
        </div>
        <AddressFormSettings />
      </div>
      <SaveNotification onSave={saveChanges} onDiscard={discardChanges} isVisible={shouldShowSaveNotification()} />
    </div>
  )
}

export default RTOSuitePage
